export default {
  indexRuns: { method: 'get', url: 'algorithm/runs' },
  showRun: { method: 'get', url: 'algorithm/runs/{id}' },
  eventsRun: { method: 'get', url: 'algorithm/runs/{id}/events' },
  applyStatusRun: { method: 'get', url: 'algorithm/runs/{id}/apply-status' },
  listApplications: { method: 'get', url: 'algorithm/applications' },

  createTimetableRun: { method: 'post', url: 'algorithm/timetable/runs' },
  listTimetableRunGroups: { method: 'get', url: 'algorithm/timetable/runs/{id}/groups' },
  resultsTimetableRun: { method: 'get', url: 'algorithm/timetable/runs/{id}/results' },
  unassignedTimetableRun: { method: 'get', url: 'algorithm/timetable/runs/{id}/unassigned' },
  summaryTimetableRun: { method: 'get', url: 'algorithm/timetable/runs/{id}/summary' },

  createTeacherAttributionRun: { method: 'post', url: 'algorithm/teacher-attribution/runs' },
  applyTeacherAttributionRun: { method: 'post', url: 'algorithm/teacher-attribution/runs/{id}/apply' },
  listTeacherAttributionRunGroups: { method: 'get', url: 'algorithm/teacher-attribution/runs/{id}/groups' },
  resultsTeacherAttributionRun: { method: 'get', url: 'algorithm/teacher-attribution/runs/{id}/results' },
  unassignedTeacherAttributionRun: { method: 'get', url: 'algorithm/teacher-attribution/runs/{id}/unassigned' },
  summaryTeacherAttributionRun: { method: 'get', url: 'algorithm/teacher-attribution/runs/{id}/summary' },
  itemsTeacherAttributionRun: { method: 'get', url: 'algorithm/teacher-attribution/runs/{id}/items' },
  teachersBoardTeacherAttributionRun: { method: 'get', url: 'algorithm/teacher-attribution/runs/{id}/teachers-board' },

  createAmbienceAllocationRun: { method: 'post', url: 'algorithm/ambience-allocation/runs' },
  applyAmbienceAllocationRun: { method: 'post', url: 'algorithm/ambience-allocation/runs/{id}/apply' },
  applySkippedAmbienceAllocationRun: { method: 'get', url: 'algorithm/ambience-allocation/runs/{id}/apply-skipped' },
  listAmbienceAllocationRunGroups: { method: 'get', url: 'algorithm/ambience-allocation/runs/{id}/groups' },
  resultsAmbienceAllocationRun: { method: 'get', url: 'algorithm/ambience-allocation/runs/{id}/results' },
  unassignedAmbienceAllocationRun: { method: 'get', url: 'algorithm/ambience-allocation/runs/{id}/unassigned' },
  summaryAmbienceAllocationRun: { method: 'get', url: 'algorithm/ambience-allocation/runs/{id}/summary' },
  dashboardAmbienceAllocationRun: { method: 'get', url: 'algorithm/ambience-allocation/runs/{id}/dashboard' },

  createAmbienceBalanceRun: { method: 'post', url: 'algorithm/ambience-balance/runs' },
  applyAmbienceBalanceRun: { method: 'post', url: 'algorithm/ambience-balance/runs/{id}/apply' },
  listAmbienceBalanceRunGroups: { method: 'get', url: 'algorithm/ambience-balance/runs/{id}/groups' },
  resultsAmbienceBalanceRun: { method: 'get', url: 'algorithm/ambience-balance/runs/{id}/results' },
  unassignedAmbienceBalanceRun: { method: 'get', url: 'algorithm/ambience-balance/runs/{id}/unassigned' },
  summaryAmbienceBalanceRun: { method: 'get', url: 'algorithm/ambience-balance/runs/{id}/summary' },
  dashboardAmbienceBalanceRun: { method: 'get', url: 'algorithm/ambience-balance/runs/{id}/dashboard' },
}
